import { propIn } from '../../common/utils/immutableHelper';

import { MNUserAnalytics } from '../../common/users/userAnalyticsTypes';

export const getUserAnalytics = (state: any): MNUserAnalytics | undefined => propIn(['analytics'])(state);
